import { FETCH_META_INFO_SUCCESS } from "./actionTypes";

const initialState = {
    data: [],
};

const metaInformationListR = (state = initialState, action) => {
    
    switch (action.type) {
        case FETCH_META_INFO_SUCCESS:
            state = { ...state, data: action.payload.response };
            return state;
    }
    return state;
}

export default metaInformationListR